let navAuth = {
  items: [
    /*{
      name: 'Profile',
      url: '/student/studentprofile',
      icon: 'icon-user',
      badge: {
        // variant: 'info',
        // text: 'Info'
      }
    },*/
    {
      name: "Resultat",
      url: "/student/studentresults",
      icon: "icon-list",
      badge: {}
    },
    {
      name: "Manual",
      url: "http://ftp.pol.se/public/LearnWARE/manual_LWC.pdf",
      icon: "circle-info",
      bage: {}
    }
  ]
};

export default navAuth;
